/**
 * SearchWordDetailContainer
 * --
 */
import { useMemo } from 'react';
import SearchWordDetailPresenter from './SearchWordDetailPresenter';
import { useGetSearchWords } from 'hooks/SearchWordHooks';
import { useGetProducts } from 'hooks/ProductHooks';
import { useGetShopInformations } from 'hooks/ShopInformationHooks';
import { useGetProductCategories } from 'hooks/ProductCategoryHooks';
const SearchWordDetailContainer = () => {
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  /* ===== STATE ===== */
  /* ===== VARIABLE ===== */
  const response = useGetSearchWords();
  const { data: productList } = useGetProducts({
    application_status: 'APPROVE',
  });
  const { data: shopInformationList } = useGetShopInformations({
    application_status: 'APPROVE',
  });
  const { data: productCategoryList } = useGetProductCategories({
    application_status: 'APPROVE',
    type: 'PRODUCT',
  });
  // const {data : productList} =
  const searchKeywordList = useMemo(() => {
    if (response && response.data) {
      const { data } = response.data;
      return data?.map((searchKeyword) => ({
        key: searchKeyword.search_word_id,
        ...searchKeyword,
      }));
    }
    return [];
  }, [response]);

  const newProductList = useMemo(() => {
    if (productList && productList.data) {
      const { data } = productList;
      return data?.map((product) => {
        const shop_information = shopInformationList?.data?.find(
          (shop) => shop?.shop_information_id === product?.shop_information_id
        );
        const product_category = productCategoryList?.data?.find(
          (category) =>
            category?.product_category_id === product?.product_category_id
        );
        return {
          ...product,
          product_category: product_category,
          shop_information: shop_information,
        };
      });
    }
    return [];
  }, [productList]);

  /* ===== FUNCTION ===== */
  /* ===== HOOKS ===== */
  /* ===== RENDER ===== */
  return (
    <>
      <SearchWordDetailPresenter
        searchKeywordList={searchKeywordList}
        productList={newProductList}
      />
    </>
  );
};

export default SearchWordDetailContainer;
